import { Fragment, type FC } from 'react';

// MUI
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

// screen
import { TeacherMenuModel } from 'modules/map/components/teacher-menu/types';
import SizedText from 'modules/map/components/pdf-print-form/styled-components/SizedText';
import PdfWeekday from 'modules/map/components/pdf-print-form/styled-components/PdfWeekday';
import { setFontSizeTeacherMenuForm } from 'modules/map/components/pdf-print-form/utils';

interface SixDaysTeacherMenuProps {
  data: TeacherMenuModel;
}

const SixDaysTeacherMenu: FC<SixDaysTeacherMenuProps> = ({ data }) => {
  const days = data.structuredData?.data?.items || [];
  const caloriesIncluded = data.structuredData.metadata.isNutritionMenu;
  const customFontSize = setFontSizeTeacherMenuForm(caloriesIncluded, days.length);

  return (
    <TableBody>
      {days.map((day, idx) => {
        const dishes = Array.from({ length: 6 }).map((_, i) => day.dishes[i] || '');
        const dishesCount = dishes.length;

        const shouldBreakNotes = day.note.includes('\n');
        const noteOfTheDay = shouldBreakNotes
          ? day.note.split('\n').map((note, index) => {
              return <Typography key={index}>{note}</Typography>;
            })
          : day.note;

        return (
          <Fragment key={idx}>
            {dishes.map((dish, index) => {
              const isFirstRow = index === 0;

              const transparentBorderBottom = {
                borderBottom: `1px solid ${index === dishes.length - 1 ? 'auto' : 'transparent'}!important`,
              };

              return (
                <TableRow key={index}>
                  {isFirstRow && <PdfWeekday rowSpan={dishesCount} datetime={day.datetime} />}
                  <TableCell style={{ textAlign: 'left' }} sx={transparentBorderBottom}>
                    <SizedText sx={{ fontSize: customFontSize }}>
                      <Typography
                        component={'span'}
                        sx={{
                          display: 'inline-block',
                          marginLeft: '5%',
                          marginRight: '5%',
                          color: dish.length === 0 ? 'transparent' : 'inherit',
                        }}
                      >
                        {index + 1}.
                      </Typography>
                      {dish}
                    </SizedText>
                  </TableCell>
                  {isFirstRow && (
                    <TableCell rowSpan={dishesCount}>
                      <SizedText sx={{ fontSize: customFontSize }}>{noteOfTheDay}</SizedText>
                    </TableCell>
                  )}
                </TableRow>
              );
            })}
          </Fragment>
        );
      })}
    </TableBody>
  );
};

export default SixDaysTeacherMenu;
